import ApplicationController from '../application_controller'

class FormController extends ApplicationController {
  static targets = ['type', 'position', 'appointmentType']
  static values = { positionRequiredTypes: Array }

  connect () {
    if (!this.hasTypeTarget || !this.hasPositionTarget) {
      return
    }

    this.parentDiv = this.positionTarget.parentElement
    this.label = this.positionTarget.parentElement.childNodes[0]
    this.positionLabelText = this.label.innerHTML

    this.typeTarget.addEventListener('change', this.toggleRequired.bind(this))
    this.typeTarget.addEventListener('change', this.toggleAppointmentType.bind(this))

    this.toggleAppointmentType()
  }

  toggleRequired () {
    const isRequired = this.positionRequiredTypesValue.includes(this.typeTarget.value)
    this.positionTarget.toggleAttribute('required', isRequired)
    this.parentDiv.classList.toggle('required', isRequired)
    this.parentDiv.classList.toggle('optional', !isRequired)
    this.label.classList.toggle('required', isRequired)
    this.label.classList.toggle('optional', !isRequired)
    this.label.innerHTML = isRequired ? `${this.positionLabelText} <abbr title="required">*</abbr>` : this.positionLabelText
  }

  toggleAppointmentType () {
    const appointmentTypeContainer = document.querySelector('div.event_appointment_type_id')
    if (!appointmentTypeContainer) return

    appointmentTypeContainer.hidden = true
    this.appointmentTypeTarget.toggleAttribute('disabled', true)

    if (this.typeTarget.value !== 'feedback_appointment') return

    appointmentTypeContainer.hidden = false
    this.appointmentTypeTarget.toggleAttribute('disabled', false)
  }
}

export default FormController
